<template>
    <div class="bm-modal-backdrop" @click="close">
        <div class="bm-modal" @click.stop>
            <header class="bm-modal-title-wrapper">
                <h3 class="bm-modal-title">{{ title }}</h3>
                <div class="bm-btn-close cursor-pointer flex justify-between items-center" @click.stop="close">
                    <CloseModalIcon />
                </div>
            </header>
            <section class="bm-modal-body">
                <slot name="modalContent" />
            </section>
        </div>
    </div>
</template>

<script>
import CloseIcon from '@/assets/svgs/CloseIcon.vue';
import CloseModalIcon from '@/assets/svgs/CloseModalIcon.vue';

export default {
    name: 'BaseModalNew',
    props: {
        title: {
            type: String,
            required: false
        }
    },
    components: {
        CloseIcon,
        CloseModalIcon
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
};
</script>

<style scoped lang="scss">
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

.bm-modal-backdrop {
    position: fixed;
    z-index: 999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    backdrop-filter: blur(2px);
    background: repeating-conic-gradient(#1B1D29 0 0.0001%, #1B1D2980 0 0.0002%) 
              60% 60%/3000px 3000px; /* Adjust values for desired noise intensity and size */
}

.bm-modal {
    position: relative;
    min-width: 400px;
    height: fit-content;
    margin: 0px 10px;
    z-index: 1000;
    background-color: #15161F;
    display: flex;
    flex-direction: column;
    border-radius: 14px;

    &__title {
        font-weight: 600;
        font-size: 24px;
        display: block;
        color: var(--black-title);
        margin-bottom: 30px;
    }

    &-footer {
        margin-top: 30px;
        display: flex;
        align-items: center;
    }
}

@media screen and (max-width: 500px) {
    .bm-modal {
        min-width: calc(100vw - 10px);
        width: calc(100vw - 10px);
    }
}

.bm-modal-header {
    padding: 20px;
}

.bm-modal-title-wrapper {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bm-modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: normal;
    color: #FFFFFF;
    margin: 0px;
    padding: 0px;
    margin-left: 16px;
}

.bm-btn-close {
    height: 24px;
    width: 24px;
    margin-right: 8px;
}

.bm-modal-body {
    padding: 0px 1rem 1rem 1rem;
    margin-top: 10px;
}
</style>